import type {
  OdReviewErrorType,
  OdReviewIssue,
} from "../../../services/odReview/odReview.types";

export const DEFAULT_HIDDEN_ERROR_TYPES: OdReviewErrorType[] = [
  "REFERENCIA_NO_VERIFICABLE",
];

export type ErrorTypeCounts = Partial<Record<OdReviewErrorType, number>>;

export function countIssuesByErrorType(
  issues: OdReviewIssue[],
): ErrorTypeCounts {
  return issues.reduce<ErrorTypeCounts>((counts, issue) => {
    counts[issue.error_type] = (counts[issue.error_type] ?? 0) + 1;
    return counts;
  }, {});
}

export function filterIssuesByErrorType(
  issues: OdReviewIssue[],
  hiddenErrorTypes: OdReviewErrorType[],
): OdReviewIssue[] {
  if (hiddenErrorTypes.length === 0) return issues;
  return issues.filter(
    (issue) => !hiddenErrorTypes.includes(issue.error_type),
  );
}

export function toggleErrorTypeVisibility(
  hiddenErrorTypes: OdReviewErrorType[],
  errorType: OdReviewErrorType,
): OdReviewErrorType[] {
  return hiddenErrorTypes.includes(errorType)
    ? hiddenErrorTypes.filter((hidden) => hidden !== errorType)
    : [...hiddenErrorTypes, errorType];
}
